import ConsigneeSaveDetail from "@/classes/models/ConsigneeSaveDetail";
import API from "@/classes/global/API";
import store from "@/store";
import Notification from "@/classes/component-classes/Notification";

export async function useMapConsigneeSave(modelValue, route, isNewContact) {

    let section = new ConsigneeSaveDetail()

    section.id = modelValue.consignee.id;
    section.name = modelValue.consignee.consigneeName ?? '';
    section.addressLine1 = modelValue.consignee.consigneeAddressLine1;
    section.addressLine2 = modelValue.consignee.consigneeAddressLine2;
    section.city = modelValue.consignee.consigneeCity;
    section.county = modelValue.consignee.consigneeCounty;
    section.postCode = modelValue.consignee.consigneePostcode;
    section.country = modelValue.consignee.consigneeCountry.split('-')[0];
    section.vatNumber = modelValue.consignee.consigneeVatNumber;
    section.contacts = modelValue.consignee.consigneeContacts;
    section.isShipperAddress = false;

    modelValue.isUpdate.consignee = true;

    const addressDetail = await API.saveAddress('consignee', section, route)

    if (addressDetail) {

        store.state.hideLoadingSpinner = true;
        store.state.banners.success = new Notification(true, 'Information Saved Successfully');

        try {

            modelValue.consignee.id = addressDetail.id;
            modelValue.consignee.consigneeContacts = addressDetail.contacts;

            if(isNewContact) {
                modelValue.consignee.consigneeContactId = addressDetail.contacts[addressDetail.contacts.length -1].id;
            }

        } catch (error) {

            //TODO log error
        }

    }
}
